import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Pipeline } from "@/components/site/Pipeline";
import { Capabilities } from "@/components/site/Capabilities";
import { Ecosystem } from "@/components/site/Ecosystem";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Transform } from "@/components/site/Transform";
import { IndiaVision } from "@/components/site/IndiaVision";
import { Projects } from "@/components/site/Projects";
import { HomeTestimonials, InsightsTeaser } from "@/components/site/HomeExtras";
import { Contact, Footer } from "@/components/site/Contact";

export default function Home() {
  const [settings, setSettings] = useState(null);
  const [projects, setProjects] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings({}));
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => setProjects([]));
  }, []);

  return (
    <div data-testid="home-page" className="relative w-full max-w-[100vw] overflow-x-clip text-slate-100">
      <Header />
      <main>
        <Hero />
        <Pipeline />
        <Capabilities />
        <Ecosystem />
        <HowItWorks />
        <Transform />
        <IndiaVision />
        <Projects projects={projects} />
        <InsightsTeaser />
        <HomeTestimonials />
        <Contact settings={settings} />
      </main>
      <Footer settings={settings} />
    </div>
  );
}
